export default __webpack_public_path__ + "static/media/Youtube.651c1216.png";